/**
 * ReportTableRow - Single row in the registration table
 * @module wellRegistrationTotals/components/organisms/RegistrationTable/ReportTableRow
 */

import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import {
  isClickableRow,
  isBoldRow,
  isBoldYearColumn,
  getRowClassName,
  formatRowLabel,
  formatNullableCell,
} from "../../../utils";

/**
 * Registration report table row with conditional styling
 * @param {Object} props
 * @param {Object} props.row - Row data
 * @param {Function} props.onRowClick - Click handler
 * @param {Object|null} props.selectedRow - Currently selected row
 */
const ReportTableRow = React.memo(({ row, onRowClick, selectedRow }) => {
  const clickable = isClickableRow(row.row_kind);
  const boldRow = isBoldRow(row.row_kind);
  const boldYearCol = isBoldYearColumn(row.row_kind);

  const boldStyle = boldRow
    ? { fontWeight: 600, textAlign: "center" }
    : { textAlign: "center" };

  const displayLabel = formatRowLabel(row.row_label, row.row_kind);

  return (
    <TableRow
      className={getRowClassName(row, selectedRow)}
      onClick={clickable ? () => onRowClick(row) : undefined}
    >
      <TableCell
        component="th"
        scope="row"
        style={{
          fontWeight: boldYearCol ? 600 : undefined,
          textAlign: "center",
        }}
      >
        {displayLabel}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.exempt_grandfathered)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.exempt_new)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.nonexempt_grandfathered)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.class1)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.class2)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.class3)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.monitor_water)}
      </TableCell>
      <TableCell align="center" style={boldStyle}>
        {formatNullableCell(row.monitor_env)}
      </TableCell>
      <TableCell
        align="center"
        style={{ fontWeight: 600, textAlign: "center" }}
      >
        {formatNullableCell(row.total)}
      </TableCell>
    </TableRow>
  );
});

ReportTableRow.displayName = "ReportTableRow";

export default ReportTableRow;
